var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6665 1.24592L12.4682 6.38321L12.5494 6.53205L12.716 6.56325L18.4677 7.64033L14.4476 11.8924L14.3311 12.0156L14.3529 12.1837L15.1059 17.9867L9.81966 15.4774L9.6665 15.4047L9.51335 15.4774L4.22709 17.9867L4.98008 12.1837L5.00189 12.0156L4.88542 11.8924L0.865353 7.64033L6.61698 6.56325L6.78362 6.53205L6.86479 6.38321L9.6665 1.24592Z",
    fill: "#A729F5",
    stroke: "#A729F5",
    strokeWidth: 0.714286
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarPurple);
export default __webpack_public_path__ + "static/media/star-purple.d937312084c987c399314433d6a445f7.svg";
export { ForwardRef as ReactComponent };